import { render, staticRenderFns } from "./checkBox.component.vue?vue&type=template&id=0a53b7ed&scoped=true&"
import script from "./checkBox.component.vue?vue&type=script&lang=js&"
export * from "./checkBox.component.vue?vue&type=script&lang=js&"
import style0 from "./checkBox.component.vue?vue&type=style&index=0&id=0a53b7ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a53b7ed",
  null
  
)

export default component.exports